import * as React from "react";
import type { SVGProps } from "react";
const SvgConsistentBrand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m32.253 58.605 20.25-20.25a5.649 5.649 0 0 0 0-7.964L28.83 6.716a2 2 0 0 0-1.415-.586H2a2 2 0 0 0-2 2v25.414a2 2 0 0 0 .587 1.415L24.26 58.605a5.65 5.65 0 0 0 7.992 0Zm19.011-26.978-.002-.002-23.67-23.672a.25.25 0 0 0-.178-.073H2a.25.25 0 0 0-.25.25v25.414c0 .066.026.13.073.177L25.5 57.369a3.899 3.899 0 0 0 5.516 0L51.262 37.12c.001 0 .002 0 .002-.002a3.899 3.899 0 0 0 0-5.492Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M26.834 18.832a.875.875 0 0 1 0 1.238l-13.6 13.6a.875.875 0 0 1-1.238-1.237l13.601-13.6a.875.875 0 0 1 1.237 0ZM30.971 23.096a.875.875 0 0 1 0 1.237l-13.6 13.6a.875.875 0 0 1-1.238-1.237l13.6-13.6a.875.875 0 0 1 1.238 0ZM35.359 27.02a.875.875 0 0 1 0 1.237l-13.6 13.6a.875.875 0 0 1-1.238-1.236l13.6-13.601a.875.875 0 0 1 1.238 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M64 43.74c0 9.124-7.398 16.522-16.523 16.522s-16.523-7.398-16.523-16.523 7.398-16.523 16.523-16.523S64 34.614 64 43.74Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M47.477 58.512c8.159 0 14.773-6.614 14.773-14.773 0-8.159-6.614-14.773-14.773-14.773-8.159 0-14.773 6.614-14.773 14.773 0 8.159 6.614 14.773 14.773 14.773Zm0 1.75C56.602 60.262 64 52.864 64 43.739s-7.398-16.523-16.523-16.523-16.523 7.398-16.523 16.523 7.398 16.523 16.523 16.523Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M38.35 36.101a1 1 0 0 1 1 1v3.979h3.978a1 1 0 0 1 0 2H38.35a1 1 0 0 1-1-1V37.1a1 1 0 0 1 1-1ZM50.626 45.399a1 1 0 0 1 1-1h4.979a1 1 0 0 1 1 1v4.978a1 1 0 1 1-2 0V46.4h-3.979a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M45.163 35.727a8.343 8.343 0 0 1 10.184 5.231.875.875 0 1 1-1.65.584A6.592 6.592 0 0 0 42.799 39.1l-3.85 3.617a.875.875 0 0 1-1.199-1.275l3.84-3.609a8.342 8.342 0 0 1 3.573-2.106Zm12.08 9.073a.875.875 0 0 1-.04 1.236l-3.84 3.61a8.343 8.343 0 0 1-13.755-3.126.875.875 0 0 1 1.65-.583 6.593 6.593 0 0 0 10.878 2.461l.013-.013.006-.006 3.85-3.618a.875.875 0 0 1 1.237.039ZM11.579 19.202a1.179 1.179 0 1 0 0-2.357 1.179 1.179 0 0 0 0 2.357Zm0 1.75a2.929 2.929 0 1 0 0-5.857 2.929 2.929 0 0 0 0 5.857Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgConsistentBrand;
